import clsx from 'clsx';

export default function Button({ className, ...rest }) {
  return <button type="button" className={clsx('', className)} {...rest} />;
}
